export const paymentTypes = [
  { key: "credit-card", name: "Card" },
  { key: "cash", name: "Cash" },
  { key: "check", name: "Cheque" },
  { key: "paypal", name: "PayPal" },
  { key: "other", name: "Other" }
];



// WEBPACK FOOTER //
// ./src/js/utils/payment-types.js